import React from "react";
import AboutSectors from "../../Components/Sectors/AboutSectors";
// import Capabilities from "../../Components/Sectors/Capabilities";
// import ServicesSectors from "../../Components/Sectors/ServicesSectors";
import KeyProjects from "../../Components/Sectors/KeyProjects";
import SubscribeTo from "../../Components/home/SubscribeTo";

const Sectors = () => {
  return (
    <div className="overflow-x-hidden tracking-wide">
      <AboutSectors />
      {/* <ServicesSectors />
      <Capabilities /> */}
      <KeyProjects />
      <SubscribeTo />
    </div>
  );
};

export default Sectors;
